import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']

  const sellers = {
    name: i18n.t('agenda.sellers'),
    path: 'configurations/grouping/sellers',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }

  const buyers = {
    name: i18n.t('agenda.buyers'),
    path: 'configurations/grouping/buyers',
    params,
    registerNavFromMenu: false,
    sc: [] // shorcuts
  }

  const menu = [
    {
      icon: 'config',
      name: i18n.t('grouping.grouping_by_buyers'),
      path: 'configurations/clients/details',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: true,
      sc: [
        {
          name: i18n.tc('companies.entity_name', 2),
          path: 'configurations/grouping/companies',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]

  if (role !== 7) {
    menu[0].sc.push(sellers)
    menu[0].sc.push(buyers)
  }

  return menu
}
